import { getTreatmentsExtensionForGraphqlBody } from '@ms/yammer-data/dist/api';
import { acquireToken } from '@ms/yammer-data/dist/authentication';
import {
  getClientForwardExperiments,
  getExperimentTreatment as getExperimentTreatmentSelector,
} from '@ms/yammer-data/dist/domains/experiments/selectors';
import { isFeatureRolloutEnabled } from '@ms/yammer-data/dist/domains/featureRollouts/selectors';
import { Experiment, FeatureRollout, Store } from '@ms/yammer-data/dist/state/types';
import { useCurrentLocale } from '@ms/yammer-i18n-react';
import { LazyRelayAppWrapper } from '@ms/yammer-relay/dist/environment';
import React, { FC } from 'react';

import { YammerWebState } from '../../../state/types';
import config from '../../config';

interface RelayAppWrapperProps {
  readonly reduxStore: Store<YammerWebState>;
  readonly etag?: string;
}

const RelayAppWrapper: FC<RelayAppWrapperProps> = ({ children, reduxStore, etag }) => {
  const state = reduxStore.getState();
  const isFeatureEnabled = (featureName: FeatureRollout) => isFeatureRolloutEnabled(state, featureName);
  const getExperimentTreatment = (experimentName: Experiment) => getExperimentTreatmentSelector(state, experimentName);
  const experiments = getClientForwardExperiments(state);
  const treatments = getTreatmentsExtensionForGraphqlBody({
    state,
    experiments,
  });
  const relay = {
    acquireToken: () => acquireToken([config.adal.resources.yammer]),
    host: config.hosts.graphql,
    treatments,
    etag,
  };
  const loki = {
    acquireToken: () => acquireToken([config.adal.resources.loki]),
    clientType: config.loki.clientType,
    region: config.loki.region,
  };
  const currentLocale = useCurrentLocale();

  return (
    <LazyRelayAppWrapper
      relay={relay}
      getExperimentTreatment={getExperimentTreatment}
      isFeatureEnabled={isFeatureEnabled}
      loki={loki}
      currentLocale={currentLocale}
    >
      {children}
    </LazyRelayAppWrapper>
  );
};

export default RelayAppWrapper;
